import React, { useState } from "react";
import SweetAlert from "react-bootstrap-sweetalert";
import { Button } from "reactstrap";
import ModalErrosList from "./ModalErrosList";

export default function ModalExcelRows({
  toggle,
  rows,
  columnNames,
  typeImport,
}) {
  const [isOpen, setIsOpen] = useState(false);
  const [errors, setErrors] = useState(null);
  const invalidRows = rows.map((row) => ({
    row: row.index + 2,
    label: row.error,
    error: Object.entries(columnNames)
      .filter(
        ([_key, value]) =>
          hasValidProperty(row, value) && row[value] === undefined
      )
      .map((e) => e[0]),
  }));

  function hasValidProperty(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
  }

  function toggleBackdrop() {
    setIsOpen(!isOpen);
  }
  function getItemByIndex(array, targetIndex) {
    return array.find((item) => item.index === targetIndex);
  }
  return (
    <>
      {
        <ModalErrosList
          isOpen={isOpen}
          toggle={() => toggleBackdrop()}
          errors={errors}
          autoFocus={true}
          centered={true}
          typeImport={typeImport}
        />
      }
      <SweetAlert
        title="Corrija os erros abaixo e reenvie a planilha  "
        warning
        confirmButtonText="Ok!"
        confirmBtnBsStyle="success"
        onConfirm={() => {
          toggle();
        }}
        style={{ width: "39.1%" }}
      >
        <div style={{ marginTop: 15 }}>
          {invalidRows.length !== 0 ? (
            invalidRows.map((irow) => (
              <p key={irow.row}>
                Linha {irow.row} , coluna(s): {irow.error.join(", ")}{" "}
                {irow.label && `- ${irow.label}`}
                <i
                  className="mdi mdi-eye"
                  style={{
                    color: "orange",
                    fontSize: 17,
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    setErrors([getItemByIndex(rows, irow.row - 2)]);
                    setIsOpen(true);
                  }}
                  title="Ver Erros"
                />
              </p>
            ))
          ) : (
            <p>Utilize o Modelo correto para fazer a importação da planilha</p>
          )}
        </div>
        {invalidRows && invalidRows?.length > 0 && (
          <Button
            onClick={() => {
              setErrors(rows);
              setIsOpen(true);
            }}
          >
            Ver Lista de erros
          </Button>
        )}
      </SweetAlert>
    </>
  );
}
